import { useMutation, useQueryClient } from '@tanstack/react-query';
import { graphQlClient } from '@config/graphqlClient';
import IncidentsGraphQL from '@graphql/incident.queries';
import { toast } from 'react-toastify';
import { PENDING_INCIDENTS_QUERY_KEY } from './usePendingIncidents';
import { INCIDENTS_BY_STATUS_QUERY_KEY } from './useIncidentsByStatus';
import { useTranslation } from '@hooks/useTranslation';

export const useAcknowledgeIncident = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (incidentId: string) => {
      const data: any = await graphQlClient.request(
        IncidentsGraphQL.mutations.acknowledgeIncident,
        { incidentId },
      );
      return data.acknowledgeIncident;
    },
    onSuccess: () => {
      toast.success(tActionMessages.incidentAcknowledgedSuccessfully);
      // Force refetch of pending incidents
      queryClient.invalidateQueries({
        queryKey: [PENDING_INCIDENTS_QUERY_KEY],
        refetchType: 'active'
      });
      // Force refetch of acknowledged incidents
      queryClient.invalidateQueries({
        queryKey: [INCIDENTS_BY_STATUS_QUERY_KEY],
        refetchType: 'active'
      });
    },
    onError: (error: any) => {
      toast.error(
        error?.response?.errors?.[0]?.message || error?.message || tActionMessages.requestError,
      );
    },
  });
};
